import ReactGA from 'react-ga4';

const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const initGA = () => {
    if (!TRACKING_ID) return;
    
    try {
        ReactGA.initialize(TRACKING_ID, {
            gaOptions: {
                cookieFlags: 'SameSite=None;Secure'
            }
        });
    } catch (error) {
        console.error('Error initializing GA:', error);
    }
};

export const logPageView = () => {
    if (!TRACKING_ID) return;

    try {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
    } catch (error) {
        console.error('Error logging page view:', error);
    }
};

export const enableAnalytics = () => {
    try {
        // Remove existing GA cookies if any
        document.cookie.split(';').forEach(cookie => {
            const [name] = cookie.split('=');
            if (name.trim().startsWith('_ga')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });
        
        // Initialize GA
        initGA();
        logPageView();
    } catch (error) {
        console.error('Error enabling analytics:', error);
    }
};

export const disableAnalytics = () => {
    if (!TRACKING_ID) return;

    try {
        // Remove GA cookies
        document.cookie.split(';').forEach(cookie => {
            const [name] = cookie.split('=');
            if (name.trim().startsWith('_ga')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });
        
        // Disable GA tracking
        (window as any)['ga-disable-' + TRACKING_ID] = true;
    } catch (error) {
        console.error('Error disabling analytics:', error);
    }
};

export const logEvent = (category: string, action: string, label?: string) => {
    if (!TRACKING_ID) return;

    ReactGA.event({
        category,
        action,
        label
    });
};

export const logError = (description: string, fatal = false) => {
    if (!TRACKING_ID) return;

    ReactGA.event({
        category: 'Error',
        action: description,
        label: fatal ? 'Fatal' : 'Non-Fatal'
    });
};

export const logSocial = (network: string, action: string, target: string) => {
    if (!TRACKING_ID) return;

    ReactGA.event({
        category: 'Social',
        action: action,
        label: `${network}:${target}`
    });
}; 